const MachineTranslationMixin = {
  localeCodetoISO(localeCode) {
    // TODO TOOLS-865 Temporary workaround for fact that Google uses "no" not "nb" for Norwegian
    if (localeCode === 'nb-NO') {
      return 'no';
    }
    return localeCode.split("-")[0];
  },
  translateString(string, targetLocaleCode, mixinRef, successCallback, sourceLocaleCode = 'en-US') {
    const url = 'https://translation.googleapis.com/language/translate/v2';
    const apiKey = 'AIzaSyCdwElsCmA_a8j2FoHlz3YoWdwwHujo14Y';
    // See TranslateService::get_source_string_info re hasHardLineBreaks
    const hasHardLineBreaks = string.match(/\n/);
    const queryString = encodeURIComponent(string.trim().replaceAll(/\n/g, '<br>'));
    const parameters = `?target=${mixinRef.localeCodetoISO(targetLocaleCode)}&source=${mixinRef.localeCodetoISO(
      sourceLocaleCode
    )}&key=${apiKey}&q=${queryString}`;
    $.ajax({
      type: 'GET',
      url: url + parameters,
      dataType: 'json',
      timeout: 3000,
      success: function(response) {
        if (response.data && response.data.translations) {
          let translatedText = response.data.translations[0].translatedText;
          if (hasHardLineBreaks) {
            translatedText = translatedText.replaceAll(/<br> ?/g, '\n');
          }
          const escapedStr = mixinRef.htmlDecode(translatedText);
          successCallback(escapedStr);
        }
      }.bind(this),
      error(jqXHR, textStatus, errorThrown) {
        console.error('error occurred', arguments);
      }
    });
  },
  htmlDecode(input) {
    const doc = new DOMParser().parseFromString(input, 'text/html');
    return doc.documentElement.textContent;
  }
};

export { MachineTranslationMixin };
